export default __webpack_public_path__ + "static/media/background.019939af.svg";